import { AppResources } from "@/constants";
import "./AccountVerificationScreen.scss";
import OnboardingHeader from "@/pages/Onboarding/components/shared/OnboardingHeader";
import VerificationForm from "@/pages/VerificationPage/components/VerificationForm";
import { useEmailVerification } from "@/pages/VerificationPage/hooks/useEmailVerification";
import { useAuthStore } from "@/utils/stores/authStore";

interface AccountVerificationScreenProps {
  onComplete?: () => void;
  redirectPath?: string;
  email?: string;
  businessSlug?: string;
}

const AccountVerificationScreen = ({
  onComplete = () => {},
  redirectPath,
  email: emailProp,
  businessSlug,
}: AccountVerificationScreenProps) => {
  const authEmail = useAuthStore((state) => state.user?.email);
  const email = emailProp || authEmail || "your email";

  const {
    isSubmitting,
    resendTimer,
    handleVerification,
    handleResendCode,
    startResendTimer,
  } = useEmailVerification({
    onSuccess: onComplete,
    redirectPath,
    businessSlug,
  });

  return (
    <div className="create-account-container">
      <div className="create-account-section">
        <OnboardingHeader />
        <VerificationForm
          onComplete={onComplete}
          email={email}
          isSubmitting={isSubmitting}
          resendTimer={resendTimer}
          onVerify={handleVerification}
          onResendCode={handleResendCode}
          startResendTimer={startResendTimer}
        />
      </div>

      <div className="create-account-visual">
        <img
          src={AppResources.onboardingVerification}
          alt="Verification"
          className="onboarding-img"
        />
      </div>
    </div>
  );
};

export default AccountVerificationScreen;
